import StyledWrapper from '../IndividualProgram/style';
import { checkOverflow } from '../../utils/utilFunctions';

import Tooltip from '@mui/material/Tooltip';

const BasicCellText = ({ cellValues, openTooltip, setOpenTooltip, StartIcon, isLink }) => (
	<Tooltip
		open={openTooltip === `${cellValues?.field}-${cellValues?.id}`}
		onOpen={(e) => checkOverflow(e) && setOpenTooltip(`${cellValues?.field}-${cellValues?.id}`)}
		onClose={() => setOpenTooltip(0)}
		arrow
		placement="top"
		title={cellValues?.formattedValue}
	>
		<StyledWrapper.CellContainer
			data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
		>
			{cellValues?.formattedValue && StartIcon && <StartIcon />}
			{!isLink ? (
				<StyledWrapper.CardRowInfo
					width={'100%'}
					data-testid={`rowInfo-${cellValues?.field}-${cellValues?.id}`}
				>
					{cellValues?.formattedValue ? cellValues?.formattedValue : '-'}
				</StyledWrapper.CardRowInfo>
			) : (
				<StyledWrapper.CardRowInfoLink
					width={'100%'}
					data-testid={`rowLink-${cellValues?.field}-${cellValues?.id}`}
				>
					{cellValues?.formattedValue ? cellValues?.formattedValue : '-'}
				</StyledWrapper.CardRowInfoLink>
			)}
		</StyledWrapper.CellContainer>
	</Tooltip>
);

export default BasicCellText;
